import { FiGrid } from "react-icons/fi";
import { useSelector } from "react-redux";
import { CATEGORIES_API, SUBCATEGORIES_API } from "../../../Utilities/APIs";
import DINPSTCRUD from "../../Partials/Layouts/CRUDs/CRUDLayouts/DINPSTCRUD/DINPSTCRUD";

function Subcategory() {

  const {employee} = useSelector(state => state.auth)

  return (
    <DINPSTCRUD
        // common props
        api={SUBCATEGORIES_API}
        screenTopicSingular={'Subcategory'}
        screenTopicPlural={'Subcategories'}
        
        // crud header props
        showTotalInHeading

        // action button props
        extraActionButton
        extraActionButtonHandleClick={'/subcatSectionCardScreens'}
        extraActionButtonChildren={<FiGrid />}
        
        // crud props
        allowCreate={employee.level === 'superAdmin'}
        allowUpdate={employee.level === 'superAdmin'}
        allowDelete={employee.level === 'superAdmin'}
        
        maxPrecedence={8}

        textDBField='engName'
        textName='English Name'
        
        // select props
        selectApi={CATEGORIES_API}
        selectType={'parent-child'}
        selectDBField={'category'}
        selectName={'Category'}
    />
  )
}

export default Subcategory